<script setup lang="ts">
  import { computed } from 'vue'
  import {
    ModalSection,
    ModalSectionHeader,
    ModalSectionHeaderTitle,
    ModalSectionHeaderDescription
  } from '@gat-ship/vue-components'
  import { useTenantUserDetailContext } from '../../composables/useTenantUserDetail'
  import { useTenantOwnedDatabases } from '../providers'
  import DatabaseAccessGrantSwitch from '../switches/DatabaseAccessGrantSwitch.vue'

  const tenantUserProvider = useTenantUserDetailContext()!
  const tenantOwnedDatabasesDataSource = useTenantOwnedDatabases()

  const tenantUser = computed(() => tenantUserProvider.tenantUser.value)

  const databases = computed(() =>
    tenantUser.value
      ? tenantOwnedDatabasesDataSource.getDatabaseAccessItems(
          tenantUser.value.userId
        )
      : []
  )
</script>

<template>
  <ModalSection v-if="tenantUser">
    <ModalSectionHeader>
      <ModalSectionHeaderTitle>Database Access</ModalSectionHeaderTitle>
      <ModalSectionHeaderDescription>
        Databases this user is allowed to access.
      </ModalSectionHeaderDescription>
    </ModalSectionHeader>
    <div v-if="databases.length" class="flex flex-col divide-y">
      <DatabaseAccessGrantSwitch
        v-for="db in databases"
        :key="db.id"
        variant="row"
        :tenant-user="tenantUser"
        :database="db"
      />
    </div>
    <div v-else class="text-muted-foreground py-3 text-sm">
      No databases available.
    </div>
  </ModalSection>
</template>
